export function ThreeIcon({ width = 41, height = 61 }) {
  return (
    <svg width={width} height={height} viewBox='0 0 43 61' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g filter='url(#filter0_i_1177_1166)'>
        <path
          d='M23.936 25.08C29.392 25.08 33.8507 26.5466 37.312 29.48C40.7734 32.4133 42.504 36.432 42.504 41.536C42.504 47.344 40.4507 51.8906 36.344 55.176C32.2374 58.4613 26.8987 60.104 20.328 60.104C11.2934 60.104 4.51736 57.4346 2.33575e-05 52.096L6.51202 43.12C8.38936 45.1146 10.4134 46.6106 12.584 47.608C14.8134 48.6053 17.336 49.104 20.152 49.104C23.0854 49.104 25.4907 48.4586 27.368 47.168C29.304 45.8186 30.272 44 30.272 41.712C30.272 39.3066 29.3334 37.488 27.456 36.256C25.5787 34.9653 23.1147 34.32 20.064 34.32C17.248 34.32 14.432 34.76 11.616 35.64L8.00802 27.192L25.344 10.736H3.87202V-4.19044e-05H39.952V10.296L23.936 25.08Z'
          fill='#F5F7F9'
        />
      </g>
      <defs>
        <filter id='filter0_i_1177_1166' x='0' y='0' width='45.5039' height='60.104' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dx='3' />
          <feGaussianBlur stdDeviation='2.5' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_1177_1166' />
        </filter>
      </defs>
    </svg>
  );
}
